export default __webpack_public_path__ + "static/media/edit_icon.fafb81fb.svg";